import { findOrganizationTab } from "@components/OrganizationPage/organizationMenuItems";
import { ORGANIZATION_ROUTE_NAME } from "@components/webmcp/navigation/routeConstants";
import { resolveProductReadinessEnabled } from "@/utils/accountProductFlags";

export const ORGANIZATION_READINESS_CATALOG_TABS = Object.freeze(["Roles", "Responsibilities"]);

export const ORGANIZATION_READINESS_CATALOG_ROUTE_NAMES = Object.freeze([
  "RoleDetail",
  "RoleDetailChild",
  "RoleDetailFromPosition",
  "ResponsibilityDetail",
  "ResponsibilityDetailChild",
  "ResponsibilityDetailFromRole",
  "ResponsibilityDetailFromRoleChild",
  "ResponsibilityDetailFromPositionRole",
  "ResponsibilityDetailFromPositionRoleChild",
]);

const READINESS_CATALOG_TAB_SLUGS = new Set(["roles", "responsibilities", "procedures"]);

/**
 * Organization Roles / Responsibilities catalog (tabs + detail routes) when the
 * Readiness product module is off (`product_readiness === false`).
 * @param {object|null|undefined} [accountDetails]
 * @returns {boolean}
 */
export function isOrganizationReadinessCatalogEnabled(accountDetails) {
  return resolveProductReadinessEnabled(accountDetails);
}

/**
 * @param {string} pathNorm Path without trailing slash (e.g. `/organization/roles/1`)
 * @param {object|null|undefined} [accountDetails]
 * @returns {boolean}
 */
export function isOrganizationReadinessCatalogBlockedPath(pathNorm, accountDetails) {
  if (isOrganizationReadinessCatalogEnabled(accountDetails)) return false;
  if (!pathNorm || !pathNorm.startsWith("/organization")) return false;

  if (pathNorm === "/organization/roles" || pathNorm.startsWith("/organization/roles/")) {
    return true;
  }
  if (
    pathNorm === "/organization/responsibilities" ||
    pathNorm.startsWith("/organization/responsibilities/")
  ) {
    return true;
  }
  if (READINESS_CATALOG_TAB_SLUGS.has(pathNorm.replace("/organization/", ""))) {
    return true;
  }
  if (pathNorm.includes("/roles/") && pathNorm.includes("/responsibilities/")) {
    return true;
  }
  if (/\/organization\/positions\/[^/]+\/roles\//.test(pathNorm)) {
    return true;
  }
  return false;
}

/**
 * @param {string} pathNorm
 * @param {{ name?: string, params?: { tab?: string } }} route
 * @param {object|null|undefined} [accountDetails]
 * @returns {string|null}
 */
export function resolveOrganizationReadinessCatalogRedirect(pathNorm, route, accountDetails) {
  if (isOrganizationReadinessCatalogEnabled(accountDetails)) return null;

  const routeName = route?.name;
  if (routeName && ORGANIZATION_READINESS_CATALOG_ROUTE_NAMES.includes(routeName)) {
    return "/organization/dashboard";
  }

  if (routeName === ORGANIZATION_ROUTE_NAME || routeName === "NewOrganization") {
    const tabParam = route?.params?.tab;
    if (tabParam && findOrganizationTab(tabParam, ORGANIZATION_READINESS_CATALOG_TABS)) {
      return "/organization/dashboard";
    }
    const slug = String(tabParam || "")
      .trim()
      .toLowerCase();
    if (slug === "procedures") {
      return "/organization/dashboard";
    }
  }

  if (isOrganizationReadinessCatalogBlockedPath(pathNorm, accountDetails)) {
    return "/organization/dashboard";
  }

  return null;
}
